import { computed, inject, Injectable, signal } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { DateConst } from 'app/shared/date.const';
import { MyHistoryScreen } from '../my-history-screen';

@Injectable({
  providedIn: 'root',
})
export class FacetFilterService {
  private auth = inject(AuthService);
  private screen = signal<MyHistoryScreen | null>(null);
  private readonly DEFAULT_START = computed(() => +DateConst.getYear(this.auth.user().birthDate) || 1900);
  private readonly DEFAULT_END = computed(() => +DateConst.getYear(new Date()));

  minStart = signal(this.DEFAULT_START());
  maxEnd = signal(this.DEFAULT_END());
  start = signal(this.minStart());
  end = signal(this.maxEnd());

  readonly isChaptersScreen = computed(() => this.screen() === MyHistoryScreen.chapters);
  readonly isStoriesScreen = computed(() => this.screen() === MyHistoryScreen.stories);
  readonly startDate = computed(() => DateConst.formatIsoDate(this.start() + ''));
  readonly endDate = computed(() => DateConst.formatIsoDate(new Date(this.end(), 11, 31)));
  readonly isFilteredByDates = signal(false);

  setMaxEnd(end: number) {
    this.maxEnd.set(end);
  }
  setMinStart(start: number) {
    this.minStart.set(start);
  }

  resetDates(start?: number, end?: number) {
    if (!start) {
      start = this.DEFAULT_START();
    }
    if (!end) {
      end = this.DEFAULT_END();
    }

    this.setMinStart(start);
    this.setMaxEnd(end);
    this.start.set(start);
    this.end.set(end);
    this.isFilteredByDates.set(false);
  }

  setScreen(screen: MyHistoryScreen) {
    this.screen.set(screen);
  }
}
